window.addEventListener('DOMContentLoaded', (event) => {
  const favoritePage = document.querySelector('.favorites')
  if (favoritePage) {
    changeTab()
  }
})

const removeClasses = (removeEl) => {
  for (const el of removeEl) {
    el.classList.remove('active')
  }
}

const displayNoneClasses = (noneEl) => {
  for (const el of noneEl) {
    el.style.display = 'none'
  }
}

const changeTab = () => {
  const coupon = document.getElementById('coupon')
  const shop = document.getElementById('shop')
  const article = document.getElementById('article')
  const movie = document.getElementById('movie')
  const gift = document.getElementById('gift')

  const couponList = document.querySelector('.couponList')
  const shopList = document.querySelector('.shopList')
  const articleList = document.querySelector('.articleList')
  const movieList = document.querySelector('.movieList')
  const giftList = document.querySelector('.giftList')

  coupon.addEventListener('click', () => {
    coupon.classList.add('active')
    couponList.style.display = 'block'
    removeClasses([shop, article, movie, gift])
    displayNoneClasses([shopList, articleList, movieList, giftList])
  })
  shop.addEventListener('click', () => {
    shop.classList.add('active')
    shopList.style.display = 'block'
    removeClasses([coupon, article, movie, gift])
    displayNoneClasses([couponList, articleList, movieList, giftList])
  })
  article.addEventListener('click', () => {
    article.classList.add('active')
    articleList.style.display = 'block'
    removeClasses([coupon, shop, movie, gift])
    displayNoneClasses([couponList, shopList, movieList, giftList])
  })
  movie.addEventListener('click', () => {
    movie.classList.add('active')
    movieList.style.display = 'block'
    removeClasses([coupon, shop, article, gift])
    displayNoneClasses([couponList, shopList, articleList, giftList])
  })
  gift.addEventListener('click', () => {
    gift.classList.add('active')
    giftList.style.display = 'block'
    removeClasses([coupon, shop, article, movie])
    displayNoneClasses([couponList, shopList, articleList, movieList])
  })
}
